import { render, staticRenderFns } from "./LandParcelAggregation.vue?vue&type=template&id=bfa79332&"
import script from "./LandParcelAggregation.vue?vue&type=script&lang=js&"
export * from "./LandParcelAggregation.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelAggregation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports